module.exports = __webpack_public_path__ + "img/02_DISTRIBUCION_2.0aa98aad.jpg";